<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @selection-change="handleSelectionChange"
        :before-close="closeDialogBefore" :upload-before="imageUploadBefore" :upload-after="imageUploadAfter" @row-update="rowUpdate"
        @size-change="pageSizeChange" @current-change="pageChange">
        <template slot="menuLeft">
          <el-button type="text" icon="el-icon-plus" size="small" plain
            @click.stop="handleAdd($route.query.rootInfo)">新增</el-button>
          <el-button type="text" icon="el-icon-delete" size="small"
            @click.stop="handleDelete">删除</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
        <!-- 查看分组明细 -->
          <el-button type="text" icon="el-icon-view" size="small" @click="handleView(scope.row)">查看明细</el-button>
        </template>
      </avue-crud>
      <el-dialog title="新增分组" :visible.sync="dialogVisible" width="50%">
        <el-form :model="formData" ref="form" label-width="120px">
          <el-form-item label="分组名称" prop="groupName" required>
            <el-input v-model="formData.groupName" placeholder="请输入分组名称" />
          </el-form-item>
          <el-form-item label="分组排序" prop="sort">
            <el-input v-model="formData.sort" placeholder="请输入序号" />
          </el-form-item>
          <!-- 工费 -->
          <el-form-item label="工费" prop="laborCost" required>
            <!-- 计数器 -->
            <el-input-number v-model="formData.laborCost" placeholder="请输入工费" :min="0" :max="1000000" />
          </el-form-item>
          <!-- 类型 -->
          <el-form-item label="分组类型" prop="type" required>
            <el-select v-model="formData.type" placeholder="请选择分组类型">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 分组明细弹窗 -->
      <group-details :visible="detailVisible" :group-id="currentGroupId" @close="closeDetail" />
    </basic-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { userTableOption } from "@/const/salesCloud/accountGroupOption";
import { findUser, openEnable, addTask,editAcct, deleteAccountGroup } from "@/api/sales/accountGroup"
// import { findByLabel } from "@/util/util"
// import { DIC } from "@/const/dic"
import { getAliyunPublicToken } from "@/api/oss/aliyun"
import oss from 'ali-oss'
import md5 from 'js-md5'
import GroupDetails from './groupDetails.vue'
export default {
  name: "user",
  components: {
    GroupDetails
  },
  data() {
    return {
      tableOption: userTableOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      dialogVisible: false,
      allAgent: [],
      formData: {
        groupName: '',
        laborCost: '',
        sort: '',
        type: '' // 默认值为吊顶
      },
      // 类型选项列表
      typeOptions: [
        { label: '防水', value: 'WATERPROOF' },
        { label: '吊顶', value: 'HANG_CEILING' }
      ],
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      detailVisible: false,
      currentGroupId: ''
    };
  },
  created() {
    /* findAgent({ page: 1, size: 1000 }).then(res => {
      let data = JSON.parse(res.data).rows;
      data.push({ id: '1', company: '平台' });
      this.allAgent = data;
    }) */
    this.handleList();
  },
  watch: {

  },
  mounted() {
  },
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 提交数据
          addTask(this.formData).then(response => {
            if (response.code == '200') {
              // 清空表单
              this.formData = {
                rootDepartId: '',
                groupName: '',
                // 工费
                laborCost: '',
                sort: '',
                type: '' // 重置为默认值
              };
              this.handleList();
              this.dialogVisible = false;
              this.$message.success('分组新增成功');
            } else {
              console.log('分组新增失败');
            }
          });
        } else {
          console.log('表单验证失败');
        }
      });
    },
    rowUpdate(row,index,done,loading) {
      console.log(row);
      editAcct(row).then(response => {
        if (response.code == '200') {
          this.$message.success('分组编辑成功');
          this.handleList();
          loading(false);
          done();
        } else {
          done();
          console.log('分组编辑失败');
        }
      })
    },
    handleAdd() {
      this.dialogVisible = true;
    },
    handleView(row) {
      this.currentGroupId = row.id;
      this.detailVisible = true;
    },
    
    closeDetail() {
      this.detailVisible = false;
      this.currentGroupId = '';
    },
    // 切换结算账号
    openEnable(row) {
      this.$confirm(`是否确认启用?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let data = {
            acctNo: row.acctNo,
          }
          openEnable(data).then(response => {
            if (response.code == '200') {
              this.$message({
                showClose: true,
                message: "启用成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error"
              })
            }

          }).catch(error => {
            this.loading = false
            this.$message({
              showClose: true,
              message: error,
              type: "error"
            })
          })
        })
        .catch(() => { });
    },
    async fnUploadRequest(option) {
      this.tableLoading = true;
      getAliyunPublicToken().then((res) => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client.multipartUpload(storeAs, option.file, {


        }).then(results => {
          let res = results.res.requestUrls;
          let files = new Array();
          for (let url in res) {
            let file = new Object();
            file.label = storeAs
            file.value = url
            files.push(file)
          }
          this.fileList = files
          this.avatar = results.res.requestUrls[0]
          this.tableLoading = false
        }).catch((err) => {
          console.log('err::: ', err);
        });
      })
    },
    imageUploadBefore(file, done) {
      done()
    },
    imageUploadAfter(res, done) {
      done()
    },
    closeDialogBefore(done) {
      this.cleanForm()
      done()
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage,
        params.size = pageSize
      findUser(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      })
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm
      params.page = page
      params.size = this.page.pageSize
      findUser(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      })
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage
      params.size = this.page.pageSize
      findUser(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      })
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm
      params.page = page.currentPage
      params.size = page.pageSize
      findUser(params).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      })
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let parmas = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      findUser(parmas).then((res) => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      })
    },
    cleanForm() {
      this.organization = {}
      this.types = []
      this.roles = []
      this.id = null
      this.fileList = []
      this.avatar = ""
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
    },
    
    // 删除分组
    handleDelete() {
      const selections = this.$refs.crud.$refs.table.selection;
      if (!selections || selections.length === 0) {
        this.$message.warning('请先选择要删除的分组');
        return;
      }
      
      this.$confirm(`确定要删除选中的${selections.length}个分组吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 获取选中的ID列表
        const ids = selections.map(item => item.id).join(',');
        
        this.tableLoading = true;
        deleteAccountGroup(ids).then(response => {
          this.tableLoading = false;
          if (response.code === '200') {
            this.$message.success('删除成功');
            this.handleList();
          } else {
            this.$message.error('删除失败：' + (response.message || '未知错误'));
          }
        }).catch(error => {
          this.tableLoading = false;
          this.$message.error('删除异常');
          console.log('删除分组异常:', error);
        });
      }).catch(() => {
        // 用户取消操作
      });
    },
  }
};
</script>

<style lang="scss">
.el-upload--text {
  text-align: left;
}

.el-upload--car-two {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 178px;
  height: 178px;
  line-height: 176px;
  vertical-align: top;
}

.el-upload--car-two image {
  width: 178px;
  height: 178px;
}

/*.el-upload .el-icon-plus{*/
/*text-align: center;*/
/*}*/
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
